<template>
  <div class="clause">
    <BaseHeader />
    <div class="container_wrap basic">
      <form name="agree">
        <BaseTitle :isStep="true" />
        <div class="container agree">
          <div
            v-for="(clause, idx) in clauseList"
            :key="`clause${idx}`"
            class="check_item"
          >
            <input
              v-model="clause.agreeYn"
              type="checkbox"
              :id="`check${idx}`"
              name="agree_checkbox"
            />
            <label v-if="clause.requiredYn" :for="`check${idx}`"
              >{{ clause.title }}에 동의함</label
            >
            <label v-else :for="`check${idx}`">{{ clause.title }}</label>
            <!-- 면책사항 내용 -->
            <div v-html="clause.bodyText" class="item_view"></div>
          </div>
        </div>

        <BaseInfo :infoList="infoList" />
        <BaseButton
          class="btnB active"
          :name="footerButtonTitle"
          :disabled="!isAllAgree"
          @click="nextPage"
        />
      </form>
    </div>
  </div>
</template>

<script>
import {
  ref,
  onBeforeMount,
  computed,
  onActivated,
  onDeactivated,
  onUpdated,
} from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import BaseHeader from "@/components/Base/BaseHeader.vue";
import BaseTitle from "@/components/Base/BaseTitle.vue";
import BaseInfo from "@/components/Base/BaseInfo.vue";
import BaseButton from "@/components/Base/BaseButton";
import useBookStep from "@/composables/useBookStep.js";

export default {
  name: "Clause",
  props: {
    page: {
      type: String,
    },
    pageName: {
      type: String,
    },
  },
  components: {
    BaseButton,
    BaseHeader,
    BaseTitle,
    BaseInfo,
  },
  setup() {
    const route = useRoute();
    const store = useStore();
    const { nextBookStep } = useBookStep();

    const serviceTypeCode = computed(
      () => store.state.common.serviceInfo.serviceTypeCode
    );
    const infoList = ["면책사항에 동의하지 않으시면 예약을 하실 수 없습니다."];
    const insuranceURL = computed(
      () => store.state.common.serviceInfo?.contentProps?.pages?.insurance?.path
    );
    const clauseCodes = computed(() => {
      const agreeCodes =
        store.state.common.serviceInfo?.contentProps?.pages?.policy?.agreeCodes;

      if (agreeCodes?.length) {
        return agreeCodes.map((code) => code.code);
      }

      return serviceTypeCode.value === "PGT-HOLIDA"
        ? ["AGC-INSURA"]
        : ["AGC-BOOK", "AGC-BOARD", "AGC-MARKET"];
    });
    const clauses = computed(() => store.state.member.clauses);

    const footerButtonTitle = computed(() =>
      serviceTypeCode.value === "PGT-HOLIDA" ? "다음" : "면책사항 동의 후 진행"
    );

    const clauseList = ref([]);
    const getClauseList = async () => {
      for (let i = 0; i < clauseCodes.value.length; i++) {
        const [clause] = await store.dispatch("common/FETCH_CLAUSE_INFO", {
          talkBbsCode: "BBS-CLAUSE",
          talkTypeCode: clauseCodes.value[i],
          displayYn: true,
        });
        if (clause) {
          clause.agreeYn = false;
          clause.requiredYn =
            clause.talkTypeCode === "AGC-MARKET" ? false : true;
          clauseList.value.push(clause);
        }
      }
    };

    const openInsurancePage = () => {
      window.open(insuranceURL.value);
    };
    const addEventInsuranceButton = () => {
      const buttonElement = document.querySelector(".insurance_button");
      if (buttonElement) {
        buttonElement.addEventListener("click", openInsurancePage);
      }
    };

    const isAllAgree = computed(() => {
      return (
        clauseList.value.length &&
        !clauseList.value.filter(
          (clause) => !clause.agreeYn && clause.requiredYn
        ).length
      );
    });

    const nextPage = async () => {
      // 약관 동의를 이미 한 경우 다음 페이지로 이동(뒤로가기로 되돌아온 경우)
      if (clauses.value.length) {
        nextBookStep(route.name);
        return;
      }

      // 약관 동의 내역을 저장
      const clausesResult = clauseList.value.map((clause) => {
        return {
          talkUid: clause.uid,
          agreeContent: clause.bodyText,
          agreeYn: clause.agreeYn,
          agreeCode: clause.talkTypeCode,
        };
      });

      if (serviceTypeCode.value === "PGT-HOLIDA") {
        for (let i = 0; i < clausesResult.length; i++) {
          await store.dispatch("member/SAVE_CLAUSES", {
            agreeCode: clausesResult[i].agreeCode,
            agreeYn: clausesResult[i].agreeYn,
          });
        }
      }
      store.dispatch("member/SET_CLAUSES", clausesResult);
      nextBookStep(route.name);
    };

    const setRefresh = (event) => {
      event.preventDefault();
      event.returnValue = "";
    };

    onBeforeMount(() => {
      getClauseList();
    });

    onUpdated(() => {
      addEventInsuranceButton();
    });

    // 새로고침시 경고창 보이도록 처리
    onActivated(() => {
      window.addEventListener("beforeunload", setRefresh);
    });
    onDeactivated(() => {
      window.removeEventListener("beforeunload", setRefresh);
    });

    return {
      infoList,
      clauseList,
      isAllAgree,
      footerButtonTitle,
      nextPage,
      openInsurancePage,
    };
  },
};
</script>

<style lang="scss" scoped></style>
